<div *ngIf="isReactive" class="itb-textarea" [formGroup]="parentForm">
  <mat-form-field>
    <textarea [ngStyle]="getResizeable()" [required]="isRequired" matInput [placeholder]="placeholder" [rows]="rows" [formControlName]="formFieldName" [maxlength]="maxlength" *ngIf="!this.isReadOnly"></textarea>
    <textarea [ngStyle]="getResizeable()" [required]="isRequired" matInput [placeholder]="placeholder" [rows]="rows" [formControlName]="formFieldName" [maxlength]="maxlength" *ngIf="this.isReadOnly" readonly></textarea>
  </mat-form-field>
</div>

<div *ngIf="!isReactive" class="itb-textarea">
    <mat-form-field>
        <textarea [ngStyle]="getResizeable()" [required]="isRequired" matInput [value]="value"
        [attr.maxlength]="maxlength" [placeholder]="placeholder" [rows]="rows" *ngIf="!this.isReadOnly" (keyup)="textValue($event)"></textarea>
        <textarea [ngStyle]="getResizeable()" [required]="isRequired" matInput [value]="value"
        [attr.maxlength]="maxlength" [placeholder]="placeholder" [rows]="rows" *ngIf="this.isReadOnly" (keyup)="textValue($event)" readonly></textarea>
      </mat-form-field>
</div>